<template>
  <v-data-table ref="dataTable"
                :items="bestand"
                :items-per-page="10"
                :headers="headers"
                :search="search"
                :custom-filter="customFilter(['Status', 'Vertragsnummer', 'Name', 'Produkt', 'Versicherungsumfang', 'Schaeden'])"
                :sort-by="'Beginn'"
                :sort-desc="true"
                :footer-props="footerProps"
                locale="de-DE"
                no-data-text="Keine Verträge vorhanden"
                no-results-text="Keine Verträge gefunden"
                must-sort
                class="bestand--table data--table">

    <!--- data rows ----------------------------------------------------------------------------->
    <template v-slot:item="{item}">
      <tr @click="$emit('show-details', { vertragsnummer: item.Vertragsnummer, newTab: false })">
        <td class="text--align--center">
          <v-tooltip top nudge-bottom="8">
            <template v-slot:activator="{on}">
              <v-icon :color="getStatusColor(item.Status)"
                      v-on="on"> {{ item.Status | statusIcon }}
              </v-icon>
            </template>
            <span class="caption">{{ item.Status }}</span>
          </v-tooltip>
        </td>
        <td class="text--align--center">{{ item.Vertragsnummer }}</td>
        <td class="single--line">{{ item.Name }}</td>
        <td>{{ item.Beginn | date }}</td>
        <td>{{ item.Produkt }}</td>
        <td>
          <versicherungsumfang :categories="item.Versicherungsumfang" />
        </td>
        <td>{{ item.Jahrespraemie | currency }}</td>
        <td class="text--align--center schaden-data"
            @click.stop="$emit('show-damages', item.Vertragsnummer)">
          <v-tooltip v-if="item.Schaeden > 0"
                     top
                     nudge-bottom="8">
            <template v-slot:activator="{on}">
              <div v-on="on">{{ item.Schaeden }}</div>
            </template>
            <span v-if="!isNaN(item.SchaedenOffen)" class="caption">{{ item.SchaedenOffen }} offen/{{ item.Schaeden - item.SchaedenOffen }} geschlossen</span>
            <span v-else class="caption">offen/geschlossen siehe Detailseite</span>
          </v-tooltip>
          <template v-else>-</template>
        </td>
        <td class="text--align--center">
          <v-tooltip top nudge-bottom="8">
            <template v-slot:activator="{on}">
              <v-icon v-if="item.Mahnstatus!=='0'"
                      :color="getMahnstatusColor(item.Mahnstatus)"
                      v-on="on">warning
              </v-icon>
              <template v-else>
                <div v-on="on"> -
                </div>
              </template>
            </template>
            <span class="caption">{{ item.Mahnstatus }}</span>
          </v-tooltip>
        </td>

        <!--- action menue ----------------------------------------------------------------------------->
        <td @click.stop>
          <v-menu :nudge-bottom="24"
                  bottom
                  left
                  content-class="table--actions">
            <template v-slot:activator="{on}">
              <v-icon v-on="on">more_vert</v-icon>
            </template>
            <v-list>
              <v-list-item @click="$emit('show-details', { vertragsnummer: item.Vertragsnummer, newTab: true })">
                <v-icon>open_in_new</v-icon>
                <v-list-item-title>Vertrag in Tab öffnen</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('show-damages', item.Vertragsnummer, true)">
                <v-icon>flash_on</v-icon>
                <v-list-item-title>Schäden in Tab öffnen</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('excel', item.Vertragsnummer)">
                <v-icon>file_download</v-icon>
                <v-list-item-title>Excel</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.allowEdit"
                           @click="$emit('edit-contract', item.Vertragsnummer)">
                <v-icon>subject</v-icon>
                <v-list-item-title>Vertrag ändern</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>
      </tr>
    </template>

  </v-data-table>
</template>
<script>
import FiltersMixin from '@/components/kundenverwaltung/FiltersMixin';
import Versicherungsumfang from "@/components/kundenverwaltung/Versicherungsumfang";
import { FOOTER_PROPS } from './tableConfig';

export default {
  name: "BestandTable",
  components: {
    Versicherungsumfang
  },
  filters: {
    statusIcon(value) {
      switch (value) {
        case 'aktiv':
          return 'done';
        case 'invitatio':
          return 'outlined_flag';
        case 'aufgehoben':
        case 'nichteinlösung':
        case 'stillgelegt':
        case 'abgelehnt':
          return 'block';
        case 'gekündigt':
        case 'erloschen':
          return 'clear';
        default:
          return '';
      }
    },
  },
  mixins: [FiltersMixin],
  props: {
    bestand: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      footerProps: FOOTER_PROPS,
      headers: [
        { text: 'Status', value: 'Status', sortable: true },
        { text: 'Vertragsnummer', value: 'Vertragsnummer', sortable: true },
        { text: 'Name', value: 'Name', sortable: true },                      //Name + Vorname
        { text: 'Beginn', value: 'Beginn', sortable: true },
        { text: 'Produkt', value: 'Produkt', sortable: true },
        { text: 'Versicherungsumfang', value: 'sortableVersicherungsumfang', sortable: true },
        { text: 'Jahresprämie brutto', value: 'Jahrespraemie', sortable: true },
        { text: 'Schäden', value: 'Schaeden', sortable: true },
        { text: 'Mahnstatus', value: 'Mahnstatus', sortable: true },
        //empty header for action menue
        { text: '', value: 'actions', sortable: false }
      ]
    };
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case 'aktiv':
          return 'success';
        case 'invitatio':
          return 'inherit';
        case 'aufgehoben':
        case 'stillgelegt':
        case 'nichteinlösung':
        case 'abgelehnt':
          return 'inherit';
        case 'gekündigt':
        case 'erloschen':
          return 'error';
        default:
          return '';
      }
    },
    getMahnstatusColor(mahnstatus) {
      switch (mahnstatus) {
        case '1': case 1:
          return 'warning';
        case '2': case 2:
          return 'error';
        default:
          return '';
      }
    }
  }
};
</script>
<style>
.bestand--table td.schaden-data:hover {
  color: #0085CF;
  text-decoration: underline;
}
</style>
